import { render, staticRenderFns } from "./SectionRules.vue?vue&type=template&id=04abe0e0&"
import script from "./SectionRules.vue?vue&type=script&lang=js&"
export * from "./SectionRules.vue?vue&type=script&lang=js&"
import style0 from "./SectionRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports